import api from '@/logic/api'

export default {
  getDirectMessages: () => api.get('/direct-messages'),
  markAsRead: (id) => api.post(`/direct-messages/${id}/mark-as-read`),
}
